import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-employee-config',
  templateUrl: './employee-config.component.html',
  styleUrls: ['./employee-config.component.scss']
})
export class EmployeeConfigComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
